import { ReactComponent as PanoramaSvg } from "../assets/header/360-panorama.svg";
import { ReactComponent as WorkExchangeSvg } from "../assets/header/work-exchange.svg";
import { ReactComponent as ELearningSvg } from "../assets/header/e-learning.svg";
import { ReactComponent as LandscapeSvg } from "../assets/header/landscape.svg";
import { ReactComponent as SculptureSvg } from "../assets/header/sculpture.svg";
import { ReactComponent as ProfileColorSvg } from "../assets/header/profile-color.svg";
import { ReactComponent as SignOutSvg } from "../assets/header/sign-out.svg";
import { ReactComponent as CommissionSvg } from "../assets/icons/commission.svg";
import { ReactComponent as ThSvg } from "../assets/header/th.svg";
import { ReactComponent as EnSvg } from "../assets/header/en.svg";
import { ReactComponent as CnSvg } from "../assets/header/cn.svg";
import ticketsPng from "../assets/header/tickets.png";

import programSketchUpImage from "../assets/icons/programs/sketchUp.png";
import program3dsMaxImage from "../assets/icons/programs/3dsMax.png";
import programRevitImage from "../assets/icons/programs/autodeskRevit.png";
import programCinema4DImage from "../assets/icons/programs/cinema4d.png";
import programUnrealImage from "../assets/icons/programs/unreal.png";
import programRhinoImage from "../assets/icons/programs/rhino.png";
import programAutocadImage from "../assets/icons/programs/autocad.png";
import programArchicadImage from "../assets/icons/programs/archicad.png";

import programVRayImage from "../assets/icons/programs/vray.png";
import programCoronaImage from "../assets/icons/programs/corona.png";
import programD5RenderImage from "../assets/icons/programs/d5render.png";
import programEnscapeImage from "../assets/icons/programs/enscape.jpg";
import programLumionImage from "../assets/icons/programs/lumion.png";

import BaacSvg from "../assets/omise/baac.svg";
import BaySvg from "../assets/omise/bay.svg";
import BblSvg from "../assets/omise/bbl.svg";
import BnpSvg from "../assets/omise/bnp.svg";
import BoaSvg from "../assets/omise/boa.svg";
import CacibSvg from "../assets/omise/cacib.svg";
import CimbSvg from "../assets/omise/cimb.svg";
import CitiSvg from "../assets/omise/citi.svg";
import DbSvg from "../assets/omise/db.svg";
import GhbSvg from "../assets/omise/ghb.svg";
import GsbSvg from "../assets/omise/gsb.svg";
import HsbcSvg from "../assets/omise/hsbc.svg";
import IbankSvg from "../assets/omise/ibank.svg";
import Icbcvg from "../assets/omise/icbc.svg";
import JmpSvg from "../assets/omise/jpm.svg";
import KbankSvg from "../assets/omise/kbank.svg";
import KkSvg from "../assets/omise/kk.svg";
import KtbSvg from "../assets/omise/ktb.svg";
import LhbSvg from "../assets/omise/lhb.svg";
import MbSvg from "../assets/omise/mb.svg";
import MegaSvg from "../assets/omise/mega.svg";
import MufgSvg from "../assets/omise/mufg.svg";
import RbsSvg from "../assets/omise/rbs.svg";
import ScSvg from "../assets/omise/sc.svg";
import ScbSvg from "../assets/omise/scb.svg";
import SmbcSvg from "../assets/omise/smbc.svg";
import TbankSvg from "../assets/omise/tbank.svg";
import TcrbSvg from "../assets/omise/tcrb.svg";
import TiscoSvg from "../assets/omise/tisco.svg";
import TmbSvg from "../assets/omise/tmb.svg";
import TtbSvg from "../assets/omise/ttb.svg";
import UobSvg from "../assets/omise/uob.svg";

export const menus = [
  { name: "Home", path: "/" },
  {
    name: "Art & Design",
    menus: [
      {
        value: "360",
        name: "Community Space",
        icon: <LandscapeSvg />,
        path: "/art-designs/community-spaces",
        active: true,
      },
      {
        value: "work-exchange",
        name: "Work Exchange",
        icon: <SculptureSvg />,
        path: "/art-designs/work-exchanges",
        active: true,
      },
      {
        value: "e-learning",
        name: "E-Learning",
        icon: <ELearningSvg />,
        active: false,
      },
    ],
  },
  { name: "Tendering", path: "/tenderings" },
  { name: "Blogs", path: "/blogs" },
  { name: "Support", path: "/support/faqs" },
];

export const profileMenus = [
  {
    value: "profile",
    name: "Profile",
    icon: <ProfileColorSvg />,
    path: "/profile",
    active: true,
  },
  // {
  //   value: "commissions",
  //   name: "Commissions",
  //   icon: <CommissionSvg />,
  //   path: "/commissions",
  //   active: true,
  // },
  {
    value: "tickets",
    name: "Support Tickets",
    icon: <img src={ticketsPng} width={22} height={22} />,
    path: "/support/tickets",
    active: true,
  },
  {
    value: "sign-out",
    name: "Logout",
    icon: <SignOutSvg />,
    path: "/logout",
    active: true,
  },
];

export const languageMenus = [
  {
    value: "en",
    name: "EN",
    icon: <EnSvg width={24} />,
    active: true,
  },
  {
    value: "th",
    name: "TH",
    icon: <ThSvg width={24} />,
    active: true,
  },
  {
    value: "cn",
    name: "CN",
    icon: <CnSvg width={24} />,
    active: true,
  },
];

export const PAGE_STATE = {
  IDLE: "idle",
  LOADING: "loading",
  ERROR: "error",
};

export const langComponent = {
  header: "header",
  notification: "notification",
  auth: "auth",
  common: "common",
  landingPage: "landingPage",
  workType: "workType",
  spaceType: "spaceType",
  styleType: "styleType",
  plan: "plan",
  profile: "profile",
  project: "project",
  certificate: "certificate",
  onboard: "onboard",
  footer: "footer",
  support: "support",
  chat: "chat",
  workExchange: "workExchange",
};

export const WORK_PROGRAMS = {
  1: programSketchUpImage,
  2: program3dsMaxImage,
  3: programRevitImage,
  4: programCinema4DImage,
  5: programUnrealImage,
  6: programRhinoImage,
  7: programAutocadImage,
  8: programArchicadImage,
};

export const WORK_RENDERERS = {
  1: programVRayImage,
  2: programCoronaImage,
  3: programLumionImage,
  4: programEnscapeImage,
  5: programD5RenderImage,
};

export const PROGRAM_MAPPING = {
  sketchUp: 1,
  "3dsMax": 2,
  revit: 3,
  cinema4D: 4,
  unreal: 5,
  rhino: 6,
  autocad: 7,
  archicad: 8,
};

export const RENDERER_MAPPING = {
  vray: 1,
  corona: 2,
  lumion: 3,
  enscape: 4,
  d5render: 5,
};

export const PROGRAM_NAME_VALUE_MAPPING = {
  sketchUp: "Sketch Up",
  "3dsMax": "3DS Max",
  revit: "Revit",
  cinema4D: "Cinema 4D",
  unreal: "Unreal",
  rhino: "Rhino",
  autocad: "AutoCad",
  archicad: "Archicad",
};

export const RENDERER_NAME_VALUE_MAPPING = {
  vray: "V-Ray",
  corona: "Corona",
  lumion: "Lumion",
  enscape: "Enscape",
  d5render: "D5 Render",
};

export const BankSvg = {
  bbl: BblSvg,
  kbank: KbankSvg,
  rbs: RbsSvg,
  ktb: KtbSvg,
  jpm: JmpSvg,
  mufg: MufgSvg,
  tmb: TmbSvg,
  scb: ScbSvg,
  citi: CitiSvg,
  smbc: SmbcSvg,
  sc: ScSvg,
  cimb: CimbSvg,
  uob: UobSvg,
  bay: BaySvg,
  mega: MegaSvg,
  boa: BoaSvg,
  cacib: CacibSvg,
  gsb: GsbSvg,
  hsbc: HsbcSvg,
  db: DbSvg,
  ghb: GhbSvg,
  baac: BaacSvg,
  mb: MbSvg,
  tbank: TbankSvg,
  bnp: BnpSvg,
  ibank: IbankSvg,
  tisco: TiscoSvg,
  kk: KkSvg,
  icbc: Icbcvg,
  tcrb: TcrbSvg,
  lhb: LhbSvg,
  ttb: TtbSvg,
};

export const bankList = {
  th: {
    bbl: {
      code: "002",
      color: "#1e4598",
      official_name: "BANGKOK BANK PUBLIC COMPANY LTD.",
      nice_name: "Bangkok Bank",
      swift_code: "BKKBTHBK",
    },
    kbank: {
      code: "004",
      color: "#138f2d",
      official_name: "KASIKORNBANK PUBLIC COMPANY LTD.",
      nice_name: "Kasikorn Bank",
      swift_code: "KASITHBK,",
    },
    rbs: {
      code: "005",
      color: "#032952",
      official_name: "THE ROYAL BANK OF SCOTLAND PLC",
      nice_name: "Royal Bank of Scotland",
      swift_code: "RBOSGB2L",
    },
    ktb: {
      code: "006",
      color: "#1ba5e1",
      official_name: "KRUNG THAI BANK PUBLIC COMPANY LTD.",
      nice_name: "Krungthai Bank",
      swift_code: "KRTHTHBK",
    },
    jpm: {
      code: "008",
      color: "#321c10",
      official_name: "JPMORGAN CHASE BANK, NATIONAL ASSOCIATION",
      nice_name: "J.P. Morgan",
      swift_code: "CHASTHBXSEC",
    },
    mufg: {
      code: "010",
      color: "#d61323",
      official_name: "THE BANK OF TOKYO-MITSUBISHI UFJ, LTD.",
      nice_name: "Bank of Tokyo-Mitsubishi UFJ",
      swift_code: "BOTKTHBX",
    },
    tmb: {
      code: "011",
      color: "#1279be",
      official_name: "TMB BANK PUBLIC COMPANY LIMITED.",
      nice_name: "TMB Bank",
      swift_code: "TMBKTHBK",
    },
    scb: {
      code: "014",
      color: "#4e2e7f",
      official_name: "SIAM COMMERCIAL BANK PUBLIC COMPANY LTD.",
      nice_name: "Siam Commercial Bank",
      swift_code: "SICOTHBK",
    },
    citi: {
      code: "017",
      color: "#1583c7",
      official_name: "CITIBANK, N.A.",
      nice_name: "Citibank",
      swift_code: "CITITHBX",
    },
    smbc: {
      code: "018",
      color: "#a0d235",
      official_name: "SUMITOMO MITSUI BANKING CORPORATION",
      nice_name: "Sumitomo Mitsui Banking Corporation",
      swift_code: "SMBCTHBK",
    },
    sc: {
      code: "020",
      color: "#0f6ea1",
      official_name: "STANDARD CHARTERED BANK (THAI) PUBLIC COMPANY LIMITED",
      nice_name: "Standard Chartered (Thai)",
      swift_code: "SCBLTHBX",
    },
    cimb: {
      code: "022",
      color: "#7e2f36",
      official_name: "CIMB THAI BANK PUPBLIC COMPANY LTD.",
      nice_name: "CIMB Thai Bank",
      swift_code: "UBOBTHBK",
    },
    uob: {
      code: "024",
      color: "#0b3979",
      official_name: "UNITED OVERSEAS BANK (THAI) PUBLIC COMPANY LIMITED",
      nice_name: "United Overseas Bank (Thai)",
      swift_code: "UOVBTHBK",
    },
    bay: {
      code: "025",
      color: "#fec43b",
      official_name: "BANK OF AYUDHYA PUBLIC COMPANY LTD.",
      nice_name: "Bank of Ayudhya (Krungsri)",
      swift_code: "AYUDTHBK",
    },
    mega: {
      code: "026",
      color: "#815e3b",
      official_name:
        "MEGA INTERNATIONAL COMMERCIAL BANK PUBLIC COMPANY LIMITED",
      nice_name: "Mega International Commercial Bank",
      swift_code: "ICBCTHBKBNA",
    },
    boa: {
      code: "027",
      color: "#e11e3c",
      official_name: "BANK OF AMERICA, NATIONAL ASSOCIATION",
      nice_name: "Bank of America",
      swift_code: "BOFATH2X",
    },
    cacib: {
      code: "028",
      color: "#0e765b",
      official_name: "CREDIT AGRICOLE CORPORATE AND INVESTMENT BANK",
      nice_name: "Crédit Agricole",
      swift_code: "AGRITHB1",
    },
    gsb: {
      code: "030",
      color: "#eb198d",
      official_name: "THE GOVERNMENT SAVINGS BANK",
      nice_name: "Government Savings Bank",
      swift_code: "GSBATHBK",
    },
    hsbc: {
      code: "031",
      color: "#fd0d1b",
      official_name: "THE HONGKONG AND SHANGHAI BANKING CORPORATION LTD.",
      nice_name: "Hongkong and Shanghai Banking Corporation",
      swift_code: "HSBCTHBK",
    },
    db: {
      code: "032",
      color: "#0522a5",
      official_name: "DEUTSCHE BANK AG.",
      nice_name: "Deutsche Bank",
      swift_code: "DEUTTHBK",
    },
    ghb: {
      code: "033",
      color: "#f57d23",
      official_name: "THE GOVERNMENT HOUSING BANK",
      nice_name: "Government Housing Bank",
      swift_code: "GOHUTHB1",
    },
    baac: {
      code: "034",
      color: "#4b9b1d",
      official_name: "BANK FOR AGRICULTURE AND AGRICULTURAL COOPERATIVES",
      nice_name: "Bank for Agriculture and Agricultural Cooperatives",
      swift_code: "BAABTHBK",
    },
    mb: {
      code: "039",
      color: "#150b78",
      official_name: "MIZUHO BANK, LTD.",
      nice_name: "Mizuho Bank",
      swift_code: "MHCBTHBK",
    },
    tbank: {
      code: "065",
      color: "#fc4f1f",
      official_name: "THANACHART BANK PUBLIC COMPANY LTD.",
      nice_name: "Thanachart Bank",
      swift_code: "THBKTHBK",
    },
    bnp: {
      code: "045",
      color: "#14925e",
      official_name: "BNP PARIBAS",
      nice_name: "BNP Paribas",
      swift_code: "BNPATHBK",
    },
    ibank: {
      code: "066",
      color: "#184615",
      official_name: "ISLAMIC BANK OF THAILAND",
      nice_name: "Islamic Bank of Thailand",
      swift_code: "TIBTTHBK",
    },
    tisco: {
      code: "067",
      color: "#12549f",
      official_name: "TISCO BANK PUBLIC COMPANY LIMITED",
      nice_name: "Tisco Bank",
      swift_code: "TFPCTHB1",
    },
    kk: {
      code: "069",
      color: "#199cc5",
      official_name: "KIATNAKIN BANK PUBLIC COMPANY LIMITED",
      nice_name: "Kiatnakin Bank",
      swift_code: "KKPBTHBK",
    },
    icbc: {
      code: "070",
      color: "#c50f1c",
      official_name:
        "INDUSTRIAL AND COMMERCIAL BANK OF CHINA (THAI) PUBLIC COMPANY LIMITED",
      nice_name: "Industrial and Commercial Bank of China (Thai)",
      swift_code: "ICBKTHBK",
    },
    tcrb: {
      code: "071",
      color: "#0a4ab3",
      official_name: "THE THAI CREDIT RETAIL BANK PUBLIC COMPANY LIMITED",
      nice_name: "Thai Credit Retail Bank",
      swift_code: "THCETHB1",
    },
    lhb: {
      code: "073",
      color: "#6d6e71",
      official_name: "LAND AND HOUSES BANK PUBLIC COMPANY LIMITED",
      nice_name: "Land and Houses Bank",
      swift_code: "LAHRTHB2",
    },
    ttb: {
      code: "076",
      color: "#ecf0f1",
      official_name: "TMBTHANACHART BANK PUBLIC COMPANY LIMITED",
      nice_name: "TMBThanachart Bank",
      swift_code: "TMBKTHBK",
    },
  },
};
